export default "__VITE_PUBLIC_ASSET__915279de__"